import { useNavigate } from "react-router-dom";
import useFocusNode from "./useFocusNode";
import { createNewProjectService } from "@uiview/views/ProjectCanvas/CreateNewProject";

export default function useCreateNewProject({ emptyNodes }) {
  const { focusLastNode } = useFocusNode();

  const navigate = useNavigate();

  const addNewProject = async () => {
    try {
      emptyNodes();
      await createNewProjectService.addNewProject(navigate);
      // 有 todotip 的节点移动视口到合适的位置
      setTimeout(() => {
        // 居中节点，但是需要减掉 todoTip 的高度
        focusLastNode({ height: -160 });
      }, 200);
    } catch (err) {
      console.error(err);
      return;
    }
  };
  return {
    addNewProject,
  };
}
